import React from 'react'
import classNames from 'classnames'
import BotAvatarPreview from 'components/settings/Routing/BotAvatarPreview'
import style from '../style.styl'

const BotMessage = ({ hideAvatar, position, avatarUrl, color, children }) => {
  const botStyle = {
    height: '2.5rem',
    width: '2.5rem',
    marginRight: '0.5rem',
    visibility: hideAvatar ? 'hidden' : 'visible',
  }

  return (
    <div className="flex">
      <BotAvatarPreview color={color} preview={avatarUrl} style={botStyle} />
      <div dangerouslySetInnerHTML={{ __html: children }} className={classNames('message', position)}/>
    </div>
  )
}

const ConversationPreview = ({ prompt, nonMatchAnswer, textColor, backgroundColor, avatarUrl }) => {
  const userMessageStyle = {
    backgroundColor,
    color: textColor,
  }
  return (
    <div className={style.ConversationPreview}>
      <span className="bot-label">Bot</span>
      <BotMessage color={backgroundColor} avatarUrl={avatarUrl}>
        {prompt}
      </BotMessage>
      <div className="message user" style={userMessageStyle}>
        Not right now!
      </div>
      <span className="bot-label">Bot</span>
      <BotMessage hideAvatar={true} position="top" color={backgroundColor} avatarUrl={avatarUrl}>
        {nonMatchAnswer}
      </BotMessage>
      <BotMessage position="bottom" color={backgroundColor} avatarUrl={avatarUrl}>
        {prompt}
      </BotMessage>
      <div className="flex-1" />
    </div>
  )
}

export default ConversationPreview



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/AnswerModal/AnswerModalNonMatchBody/conversationPreview.js